import * as React from 'react';
import { EPaymentStatus } from '../../../../services/billingPayments';
import { IPaymentStatusProps } from './types';
import * as styles from './PaymentStatus.css';
import { useDeviceCondition } from '../../../../hooks';
import classNames from 'classnames';
import { PaymentStatusCanceled, PaymentStatusPending, PaymentStatusSucceeded } from './components';

export const PaymentStatus = ({ status, handleRetryClick }: IPaymentStatusProps) => {
  const rootStyle = useDeviceCondition(styles['desktop'], styles['mobile']);

  return (
    <div className={classNames(styles['wrapper'], rootStyle)}>
      {status === EPaymentStatus.Pending && <PaymentStatusPending />}

      {status === EPaymentStatus.Succeeded && <PaymentStatusSucceeded />}

      {status === EPaymentStatus.Canceled && <PaymentStatusCanceled onClick={handleRetryClick} />}
    </div>
  );
};
